import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  box: {
    display: 'flex',
    justifyContent: 'center',
    height: theme.spacing(36.25),
    marginTop: -88,
  },
  cloudSelectorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  cloudSelectorWidthHeight: { height: theme.spacing(5.5) },
  selectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  radioButtonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1.75),
  },
  modalContentWrapper: {
    marginBottom: theme.spacing(-1),
  },
  modalContentTitle: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    marginBottom: theme.spacing(1.5),
    lineHeight: '20px',
  },
  externalLinkIcon: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.select.light,
    textDecoration: 'none',
    width: 'fit-content',
    alignItems: 'center',
    flexDirection: 'row',
    letterSpacing: '0.1px',
    marginRight: theme.spacing(1.5),
  },
  disabledSelectWrapper: {
    opacity: 0.39,
    width: '100%',
  },
}))
